import {
  updateMyTripDetailsQueryAction,
  getWalletRechargeStatus,
  getRescheduleStatus,
} from '@ibibo/myaccount-reducer';

import D404 from '@ibibo/d404';

import MyTrips from '../pages/myTripsListing/myTrips';
import MyTripsDetails from '../pages/myTripsDetails/myTripsDetails';
import CancelFlow from '../pages/CancelFlow/CancelFlow';
import RefundBreakup from '../pages/RefundBreakup/RefundBreakup';
import RescheduleFlow from '../pages/RescheduleFlow/RescheduleFlow';
import Wallet from '../../stories/components/Wallet/Wallet';
import Settings from '../../stories/components/Settings/Settings';
import AisProfile from '../../stories/components/AisProfile/AisProfile';
import NameChange from '../pages/NameChange/NameChange';
import TerminationPage from '../../storie../../stories/components/LoyalityAgreement/Termination&Agreement/TerminationPage';
import LoyalityAgreementPage from '../../storie../../stories/components/LoyalityAgreement/Termination&Agreement/LoyaltyAgreementPage';
import RefundRaiseRequest from '../../stories/components/RefundRaiseRequest/RefundRaiseRequest';
import SavedGstList from '../../stories/components/Settings/RightBlock/ManageGst/SavedGstList/SavedGstList';
import AddGstMobile from '../../stories/components/Settings/RightBlock/ManageGst/AddGstMobile/AddGstMobile';

export default [
  {
    path: '/:baseUrl/details/:id/',
    component: MyTripsDetails,
    key: 'MyTripsDetails',
    populateStoreFromUrl: ({params, searchString}, dispatch) => {
      const searchQuery = new URLSearchParams(searchString);
      if (params.id && searchQuery.get('search_id')) {
        const searchid = searchQuery.get('search_id').split('_')[0];
        const parentId = params.id.split('_')[0];
        const mobile = params.id.split('_')[1];
        return dispatch(
          updateMyTripDetailsQueryAction({
            parentID: parentId,
            childID: searchid,
            mobile,
          }),
        );
      }
    },
  },
  {
    path: '/:baseUrl/cancel/:id',
    component: CancelFlow,
    key: 'MyTripsCancel',
    populateStoreFromUrl: ({params, searchString}, dispatch) => {
      const searchQuery = new URLSearchParams(searchString);
      if (params.id && searchQuery.get('search_id')) {
        const searchid = searchQuery.get('search_id').split('_')[0];
        const parentId = params.id.split('_')[0];
        const mobile = params.id.split('_')[1];
        return dispatch(
          updateMyTripDetailsQueryAction({
            parentID: parentId,
            childID: searchid,
            mobile,
          }),
        );
      }
    },
  },
  {
    path: '/:baseUrl/refunddetails/:id',
    component: RefundBreakup,
    key: 'MyTripsRefundBreakup',
    populateStoreFromUrl: ({params, searchString}, dispatch) => {
      const searchQuery = new URLSearchParams(searchString);
      if (params.id && searchQuery.get('search_id')) {
        const searchid = searchQuery.get('search_id').split('_')[0];
        const parentId = params.id.split('_')[0];
        const mobile = params.id.split('_')[1];
        return dispatch(
          updateMyTripDetailsQueryAction({
            parentID: parentId,
            childID: searchid,
            mobile,
          }),
        );
      }
    },
  },
  {
    path: '/:baseUrl/modify/:id',
    component: RescheduleFlow,
    key: 'MyTripsModify',
    populateStoreFromUrl: ({params, searchString}, dispatch) => {
      const searchQuery = new URLSearchParams(searchString);
      if (params.id && searchQuery.get('search_id')) {
        const searchid = searchQuery.get('search_id').split('_')[0];
        const parentId = params.id.split('_')[0];
        const mobile = params.id.split('_')[1];
        if (searchQuery.has('pay_status')) {
          dispatch(getRescheduleStatus(searchQuery));
        }
        return dispatch(
          updateMyTripDetailsQueryAction({
            parentID: parentId,
            childID: searchid,
            mobile,
          }),
        );
      }
    },
  },
  {
    path: '/:baseUrl/name/modify/:id',
    component: NameChange,
    key: 'MyNameModify',
    populateStoreFromUrl: ({params, searchString}, dispatch) => {
      const searchQuery = new URLSearchParams(searchString);
      if (params.id && searchQuery.get('search_id')) {
        const searchid = searchQuery.get('search_id').split('_')[0];
        const parentId = params.id.split('_')[0];
        const mobile = params.id.split('_')[1];
        return dispatch(
          updateMyTripDetailsQueryAction({
            parentID: parentId,
            childID: searchid,
            mobile,
          }),
        );
      }
    },
  },
  {
    path: '/mytrips/',
    component: MyTrips,
    key: 'MyTrips',
  },
  {
    path: '/mywallet/',
    component: Wallet,
    key: 'wallet',
    populateStoreFromUrl: ({searchString}, dispatch) => {
      const searchQuery = new URLSearchParams(searchString);
      if (searchQuery.has('pay_status')) {
        dispatch(getWalletRechargeStatus(searchQuery));
      }
    },
  },
  {
    path: '/mysettings/',
    component: Settings,
    key: 'Settings',
  },
  {
    path: '/myAddGstList',
    component: AddGstMobile,
    key: 'Settings',
  },
  {
    path: '/mysuppliersettings/',
    component: AisProfile,
    key: 'AISProfile',
  },
  {
    path: '/myterminationagreement/',
    component: TerminationPage,
    key: 'termination Agreement',
    showHeader: false,
    showFooter: false,
  },
  {
    path: '/myloyaltyagreement/',
    component: LoyalityAgreementPage,
    key: 'Loyalty Agreement',
    showHeader: false,
    showFooter: false,
  },
  {
    path: '/myrefundrequests/',
    component: RefundRaiseRequest,
    key: 'Refund Request',
    showHeader: true,
    showFooter: true,
  },
  {
    path: '*',
    component: D404,
    key: 'hotels404',
  },
];
